import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
	addCandidateToCampaign,
	addCampaign as addCampaignApi,
	getCampaign,
	removeFromCampaign,
	searchCampaigns
} from 'util/Api';

const resetState = createAction('campaign/resetState');

const addToCandidate = createAsyncThunk(
	'campaign/addToCandidate',
	async ({ campaignId, candidateId }, { rejectWithValue }) => {
		try {
			return await addCandidateToCampaign(campaignId, candidateId);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const addCampaign = createAsyncThunk('campaign/addCampaign', async (args, { rejectWithValue }) => {
	try {
		return await addCampaignApi(args);
	} catch (err) {
		return rejectWithValue(err);
	}
});

const getById = createAsyncThunk(
	'campaign/getById',
	async ({ campaignId }, { rejectWithValue }) => {
		try {
			return await getCampaign(campaignId);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const removeCandidate = createAsyncThunk(
	'campaign/removeCandidate',
	async ({ campaignId, candidateId }, { rejectWithValue }) => {
		try {
			return await removeFromCampaign(campaignId, candidateId);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

const search = createAsyncThunk(
	'campaign/search',
	async ({ value, itemsPerPage }, { rejectWithValue }) => {
		try {
			return await searchCampaigns(value, itemsPerPage);
		} catch (err) {
			return rejectWithValue(err);
		}
	}
);

export const campaignActions = {
	resetState,
	addToCandidate,
	addCampaign,
	getById,
	removeCandidate,
	search
};
